/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartDto } from './CartDto';
import {
    CartDtoFromJSON,
    CartDtoFromJSONTyped,
    CartDtoToJSON,
} from './CartDto';

/**
 * 
 * @export
 * @interface InitiatePendingPaymentResponse
 */
export interface InitiatePendingPaymentResponse {
    /**
     * 
     * @type {CartDto}
     * @memberof InitiatePendingPaymentResponse
     */
    cartDto?: CartDto;
    /**
     * 
     * @type {string}
     * @memberof InitiatePendingPaymentResponse
     */
    pendingPaymentType: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePendingPaymentResponse
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePendingPaymentResponse
     */
    correlationId: string;
    /**
     * 
     * @type {number}
     * @memberof InitiatePendingPaymentResponse
     */
    totalAmount?: number;
}

/**
 * Check if a given object implements the InitiatePendingPaymentResponse interface.
 */
export function instanceOfInitiatePendingPaymentResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pendingPaymentType" in value;
    isInstance = isInstance && "orderReference" in value;
    isInstance = isInstance && "correlationId" in value;

    return isInstance;
}

export function InitiatePendingPaymentResponseFromJSON(json: any): InitiatePendingPaymentResponse {
    return InitiatePendingPaymentResponseFromJSONTyped(json, false);
}

export function InitiatePendingPaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiatePendingPaymentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cartDto': !exists(json, 'cartDto') ? undefined : CartDtoFromJSON(json['cartDto']),
        'pendingPaymentType': json['pendingPaymentType'],
        'orderReference': json['orderReference'],
        'correlationId': json['correlationId'],
        'totalAmount': !exists(json, 'totalAmount') ? undefined : json['totalAmount'],
    };
}

export function InitiatePendingPaymentResponseToJSON(value?: InitiatePendingPaymentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cartDto': CartDtoToJSON(value.cartDto),
        'pendingPaymentType': value.pendingPaymentType,
        'orderReference': value.orderReference,
        'correlationId': value.correlationId,
        'totalAmount': value.totalAmount,
    };
}

